enum RoutePaths {
  vaults = "/vaults",
  gov = "/gov",
  vulnerability = "/vulnerability",
  vault_editor = "/vault-editor",
  committee_tools = "/committee-tools",
  profile = "/profile",
  leaderboard = "/leaderboard",
  payouts = "/committee-tools/payouts",
  submissions = "/committee-tools/submissions",
  airdrop_machine = "/airdrop_machine",
  airdrop = "/airdrop",
  myWallet = "/my-wallet",
}

export { RoutePaths };
